import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { from,  forkJoin, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var particlesJS: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  subNotifier = new Subject();

  constructor(private router: Router,
    private elRef:ElementRef
  ) { }

  
  ngOnInit(): void {

    setTimeout(function () {particlesJS.load('particles', 'assets/js/particlesjs-config.json', function() {
      
    });}, 500);

    this.playVideo();
  
  }
  ngOnDestroy() {
    //unsubscribe
    this.subNotifier.next();
    this.subNotifier.complete();
  }

  startNow ()
  {
    let authData = JSON.parse(localStorage.getItem('authorizationData') || null);

    if(!authData)
    {
      this.router.navigate(['login']);
    }
  }

  playVideo()
  {
    //const video = <HTMLVideoElement>document.querySelector("video");
    const video = this.elRef.nativeElement.querySelector('video');
    //var video = this.elRef.nativeElement.getElementById('myVideo');

    if(!video) return;

    //video.defaultPlaybackRate = 2.0;
    //video.playbackRate = 0.5;

    const sub = from(video.play());

    sub.pipe(takeUntil(this.subNotifier)).subscribe(s =>
    {
    },
    error =>
    {
      // Autoplay was prevented.
      video.muted = true;
      //video.playbackRate = 0.5;
      video.play();
    }
    );
    
    /*
    const promise = video.play();
    if(promise !== undefined){
        promise.then(() => {
            // Autoplay started
            //video.muted = true;
           //video.playbackRate = 0.7;
           //video.play();
        }).catch(error => {
            // Autoplay was prevented.
            video.muted = true;
            video.playbackRate = 0.5;
            video.play();
        });
    }*/
  }

  isLoggedIn() {
    let authData = JSON.parse(localStorage.getItem('authorizationData') || null);
    return authData;
  }
}
